import { GenericMultiSelect } from "@/AdminComponent/GenericMultiSelect";
import { useFetchAllTypesOfContents } from "@/data/swrs/trc";
import { LESSON_PLAN_LABELS } from "@/constants/lessonPlanLabels";


export function RelatedVideosDropdown({ value, onChange }) {
  const {data:contents, isLoading } = useFetchAllTypesOfContents()

  if (isLoading) return <div>Loading...</div>;

  const options = (contents?.data || []).filter((content) =>
    !content?.model || ['Video', 'LessonPlan'].includes(content.model)
  );
  const selectedValues = value.map((id) => {
    const content = options.find((c) => c._id === id);
    return content || { _id: id, title: 'Selected related video' };
  });

  const formatOptionLabel = (option) => {
    const typeLabel = option?.model === 'LessonPlan' ? LESSON_PLAN_LABELS.PROGRESSIVE : 'Video';
    return option?.model ? `${option.title} - ${typeLabel}` : option.title;
  };

  return (
    <GenericMultiSelect
      sectionLabel="Related Videos"
      inputLabel="Search & select videos"
      selectedValues={selectedValues}
      onSelectionChange={(items) => onChange(items.map((item) => item._id))}
      fetchOptions={async (query) => {
        if (!query) return options;

        return options
          ?.filter((c) =>
            formatOptionLabel(c).toLowerCase().includes(query.toLowerCase())
          );
      }}
      getOptionLabel={formatOptionLabel}
      compareOptions={(a, b) => a._id === b._id}
      debounceDelay={0} 
      clearOptionsOnEmptyQuery={false}
      sx={{ mb: 2 }}
    />
  );
}
